import React from 'react';

const Footer = () => {
  const date = new Date().getFullYear();

  const mainFooter = {
    // background: '#3131d2',
    color: '#000000',
    height: '40px',
    letterSpacing: '1px',
    lineHeight: '40px',
    textAlign: 'center',
  };

  return (
    <footer style={mainFooter}>
      <div>
        <small>{`\u00A9 ${date} JaymesYoung`}</small>
      </div>
    </footer>
  );
};

export default Footer;
